import {
	addNotifications,
	clearNotificationsValidate,
	// showInside,
} from '../store/modules/app/notifications/actions';

const messagesNetworkError = [
	{
		typeError: 'Network Error',
		messageToShow:
			'Ocorreu uma instabilidade com a sua rede e não foi possível enviar a requisição para o servidor, tente novamente.',
	},
	{
		typeError: 'ERR_INTERNET_DISCONNETED',
		messageToShow:
			'Ocorreu uma instabilidade com a sua rede e não foi possível enviar a requisição para o servidor, tente novamente.',
	},
];

const clearEmptyValues = (valuesToTreat: any[]) => {
	return valuesToTreat.filter(Boolean) || valuesToTreat;
};

const generateServiceErrorNotification = (
	message: string,
	integrador?: string,
	requestMethod?: string,
	requestDate?: string,
	status?: string,
	requestTrace?: string,
) => {
	const dataErrorMessage = [
		`Mensagem: ${message}`,
		`${integrador ? `Integrador: ${integrador}` : ''}`,
		`${status ? `Status: ${status}` : ''}`,
		`${requestMethod ? `Método: ${requestMethod}` : ''}`,
		`Data: ${requestDate || new Date().toLocaleString()}`,
		`${requestTrace ? `Trace: ${requestTrace}` : ''}`,
	];

	return clearEmptyValues(dataErrorMessage);
};

export default function handleFailed(
	errors: any,
	semNotificacao?: boolean,
	defaultErrorMessage?: string,
	serviceIntegrador?: boolean,
	responseErrorFormatted?: any,
) {
	let notifications: any = [];

	clearNotificationsValidate();

	const isNetworkError = messagesNetworkError.find(
		item =>
			item.typeError.toLowerCase() ===
			(errors.message ? errors.message.toLowerCase() : ''),
	);

	if (errors && !isNetworkError) {
		Object.keys(errors).forEach((item: any) => {
			if (
				serviceIntegrador &&
				errors[item]?.data &&
				(errors[item]?.data.transacao || errors[item]?.data.trace) &&
				responseErrorFormatted
			) {
				if (errors[item]?.data?.mensagem) {
					notifications = [
						`Mensagem: ${errors[item]?.data?.mensagem}`,
						`Integrador: ${responseErrorFormatted.requestUrl}`,
						`Status: ${responseErrorFormatted.statusCode}`,
						`Método: ${responseErrorFormatted.requestMethod}`,
						`Data: ${responseErrorFormatted.resquestDate}`,
						`Trace: ${responseErrorFormatted.requestTrace}`,
					];
				} else if (errors[item]?.data?.messages) {
					notifications = [
						`Mensagem: ${errors[item]?.data?.messages}`,
						`Integrador: ${responseErrorFormatted.requestUrl}`,
						`Status: ${responseErrorFormatted.statusCode}`,
						`Método: ${responseErrorFormatted.requestMethod}`,
						`Data: ${responseErrorFormatted.resquestDate}`,
						`Trace: ${responseErrorFormatted.requestTrace}`,
					];
				} else if (errors[item]?.data?.mensagens) {
					notifications = [
						`Mensagem: ${errors[item]?.data?.mensagens}`,
						`Integrador: ${responseErrorFormatted.requestUrl}`,
						`Status: ${responseErrorFormatted.statusCode}`,
						`Método: ${responseErrorFormatted.requestMethod}`,
						`Data: ${responseErrorFormatted.resquestDate}`,
						`Trace: ${responseErrorFormatted.requestTrace}`,
					];

					// Tratamento mensagem status 502 para o serviço de cep.
					if (
						responseErrorFormatted.requestUrl === 'cep/v2/enderecos' &&
						responseErrorFormatted.statusCode === 502
					) {
						notifications[0] =
							'Mensagem: O Servidor intermediário recebeu uma resposta inválida do servidor para o qual a requisição foi encaminhada.';
					}
				} else {
					notifications = [
						`Mensagem: Serviço indisponível ou erro de conexão`,
						`Integrador: ${responseErrorFormatted.requestUrl}`,
						`Status: ${responseErrorFormatted.statusCode}`,
						`Método: ${responseErrorFormatted.requestMethod}`,
						`Data: ${responseErrorFormatted.resquestDate}`,
						`Trace: ${responseErrorFormatted.requestTrace}`,
					];
				}
			} else if (errors[item]?.data?.mensagens) {
				notifications = errors[item]?.data?.mensagens;
			} else if (errors[item]?.data?.mensagem) {
				notifications.push(errors[item]?.data?.mensagem);
			} else if (errors[item]?.data?.message) {
				notifications.push(errors[item]?.data?.message);
			} else if (errors[item]?.data?.messages) {
				if (Array.isArray(errors[item]?.data?.messages)) {
					notifications = errors[item]?.data?.messages;
				} else {
					notifications = [errors[item]?.data?.messages];
				}
			} else if (errors.mensagem_erro) {
				notifications.push(errors.mensagem_erro);
			} else if (errors[item]?.data?.mensagemErro) {
				if (Array.isArray(errors[item]?.data?.mensagemErro)) {
					notifications = errors[item]?.data?.mensagemErro;
				} else {
					notifications = [errors[item]?.data?.mensagemErro];
				}
			} else if (errors[item]?.data?.WebErrorMessage) {
				if (Array.isArray(errors[item]?.data?.WebErrorMessage)) {
					notifications = errors[item]?.data?.WebErrorMessage;
				} else {
					notifications = [errors[item]?.data?.WebErrorMessage];
				}
			} else if (errors[item]?.data?.ErrorMessage) {
				if (Array.isArray(errors[item]?.data?.ErrorMessage)) {
					notifications = errors[item]?.data?.ErrorMessage;
				} else {
					notifications = [errors[item]?.data?.ErrorMessage];
				}
			} else if (item === 'code' && errors[item] === 'ECONNABORTED') {
				notifications =
					errors.config?.timeoutErrorMessage &&
					errors.config.timeoutErrorMessage !== ''
						? errors.config.timeoutErrorMessage
						: 'Tempo máximo para o retorno desta requisição foi excedido. Tente novamente.';
			} else if (serviceIntegrador && errors[item]?.data) {
				notifications = [errors[item]?.data];
			}

			if (errors[item]?.data?.numRg) {
				notifications.push(errors[item]?.data?.numRg);
			}

			if (errors[item]?.data?.numeroRg) {
				notifications.push(errors[item]?.data?.numeroRg);
			}
		});
	} else {
		notifications = [
			...generateServiceErrorNotification(
				isNetworkError?.messageToShow || '',
				responseErrorFormatted?.requestUrl,
				responseErrorFormatted?.requestMethod,
				responseErrorFormatted?.resquestDate,
				'',
				'',
			),
		];
	}

	if (notifications.length === 0) {
		notifications = [
			defaultErrorMessage && defaultErrorMessage !== ''
				? defaultErrorMessage
				: 'Serviço indisponível ou erro de conexão. Entre em contato com o suporte.',
		];
	}

	if (notifications.length === 1 && !semNotificacao) {
		addNotifications({ errors: notifications });
	} else if (notifications.length > 1 && !semNotificacao) {
		addNotifications({ errors: notifications });
	} else if (!semNotificacao) {
		addNotifications({ errors: notifications });
	}

	return notifications;
}

export async function handleFailedBody(errors: any) {
	let errorBody = 0;

	Object.keys(errors).forEach((item: any) => {
		if (errors[item]?.status && errors[item]?.data) {
			errorBody = errors[item];
		}
	});
	return errorBody;
}

export function handleValidations(errors: any) {
	addNotifications({ errors });
}
